import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../../../shared/components/Breadcrumbs";
import {
  TICKETING,
  TICKET_DETAILS,
  SEND,
  BACKTOLIST,
  ACTIVE_BORDER,
  ACTIVE_BG,
  ACTIVE_TEXT,
  INACTIVE_TEXT,
  WORKFLOW
} from "../../../../shared/constants/Constants";
import DefaultButton from "../../../../shared/components/DefaultButton";
import TicketGeneral from "./TicketGeneral";
import TicketMessages from "./TicketMessages";
import TicketSolution from "./TicketSolution";
import TicketHistory from "./TicketHistory";
import TicketArticle from "./TicketArticle";
import FormikSelectField from "../../../../shared/components/FormikSelectField";
import { loadActiveEmployeeDataRequest } from "../../../employees/redux/Actions";
import { loadStatusDropdownRequest } from "../../../vision_hub/escalation_rule_builder/redux/Actions";
import {
  loadGroupByTypeAdminGetDataRequest,
  loadGroupByIDJobTitlesGetDataRequest,
} from "../../../group_jobtitles/redux/Actions";
import {
  loadTicketListGetDataRequest,
  loadWorkflowDetailsGetDataRequest,
  loadTicketDetailsGetDataRequest,
  loadTicketMessageAddDataRequest,
  loadTicketDetailsAddDataRequest,
  loadWorkflowDetailsAddDataRequest,
  loadWorkflowDeleteDataRequest,
} from "../redux/Actions";
import { loadCategorySubCategoryConfigDataRequest } from "../../../vision_hub/categories/redux/Actions";
import TicketSendMessage from "./TicketSendMessage";
import Modalpopup from "../../../../shared/components/Modalpopup";
import ConfirmModal from "../../../../shared/components/ConfirmModal";
import { PrevNextButtons } from "../../../../shared/components/PrevNextButtons";
import { useFormikContext } from "formik";
import { usePrompt } from "./usePrompt";
import TicketInsights from "./TicketInsights";
import "./Ticketing.css";



const WorkflowDetails = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let params = useParams();

  const assignedAdminGroup = state?.assignedAdminGroup;
  const assignedToName = state?.assignedToName;

  console.log("Workflow ID:", id);
  console.log("Assigned Admin Group:", state);
  const { adminGroup, group } = useSelector((store) => store.groupJobtitle);
  const { workflowdetails, error, loading, workflowSaveSuccess, workflowDeleteSuccess  } = useSelector( (store) => store.ticketing);
  console.log("Workflow Details from Redux:", workflowdetails);
  const { categoryconfig } = useSelector((store) => store.categories);
  const { statusList, loadingStatus } = useSelector((state) => state.ticketingDropdowns);
  const [currentTracker, setCurrentTracker] = useState(1);
  // const [showOverflow, setShowOverflow] = useState(false);
  // const overflowRef = useRef(null);
  const tabsContainerRef = useRef(null);
  const [employees, setEmployees] = useState([]);
  const [showSendModal, setShowSendModal] = useState(false);
  const emp_no = JSON.parse(localStorage.getItem("emp_no"));
  const employee = JSON.parse(localStorage.getItem("employee"));
  const [newMessageAttachments, setNewMessageAttachments] = useState([]);
  const originalValuesRef = useRef(null);
  const [isChanged, setIsChanged] = useState(false);
  const [shouldReload, setShouldReload] = useState(false);
  const [articleID, setArticleID] = useState( workflowdetails?.category_config_id || ""  );
  const [showOverflowMenu, setShowOverflowMenu] = useState(false);
  const overflowRef = useRef(null);
  const firstNotes = Array.isArray(workflowdetails?.internal_notes) ? workflowdetails.internal_notes[0] : workflowdetails?.internal_notes;
  const formikRef = useRef();
  const [showSidePanel, setShowSidePanel] = useState(false);
  const canDelete = ["363647", "135205", "134321"].includes(String(emp_no));
  const [showDeleteModal, setShowDeleteModal] = useState(false);  
  const getLatestSolution = (solutions) => {
    if (!Array.isArray(solutions) || solutions.length === 0) return "";
    return solutions[0]?.solution_text || "";  // ← first item is the latest
  };
      
// "save" or "complete"
  console.log("WOrkflowdate", workflowdetails);
  // index of first visible tab
  const [startIndex, setStartIndex] = useState(0);
  const workflowTabs = React.useMemo(() => {
    if (!workflowdetails?.tickets?.length) return [];

    return workflowdetails.tickets
      .slice()
      .sort((a, b) => {
        const aSeq = a.sequence_order ?? Infinity;
        const bSeq = b.sequence_order ?? Infinity;
        return aSeq - bSeq;
      })
      .map((ticket, idx) => ({
        id: ticket.sequence_order ?? `t-${ticket.ticket_id}`,
        serial: idx + 1,          // ← display number, always sequential
        label: ticket.admin_group,
        ticketData: ticket,
      }));
  }, [workflowdetails]);

  useEffect(() => {
    if (workflowSaveSuccess && formikRef.current) {
      const currentValues = formikRef.current.values;

      originalValuesRef.current = JSON.parse(
        JSON.stringify(currentValues)
      );

      formikRef.current.resetForm({ values: currentValues });

      setIsChanged(false);
    }
  }, [workflowSaveSuccess]);

  const MAX_TABS_PER_PAGE = 3;

  const visibleTabs = workflowTabs.slice(
    startIndex,
    startIndex + MAX_TABS_PER_PAGE
  );
  const showArrows = workflowTabs.length > MAX_TABS_PER_PAGE;

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) =>
      Math.min(prev + 1, workflowTabs.length - MAX_TABS_PER_PAGE)
    );
  };

  useEffect(() => {
    if (!currentTracker || !workflowTabs.length) return;

    const activeIndex = workflowTabs.findIndex(
      (tab) => tab.id === currentTracker
    );

    if (activeIndex === -1) return;

    // If active tab is left of window
    if (activeIndex < startIndex) {
      setStartIndex(activeIndex);
    }

    // If active tab is right of window
    if (activeIndex >= startIndex + MAX_TABS_PER_PAGE) {
      setStartIndex(activeIndex - MAX_TABS_PER_PAGE + 1);
    }
  }, [currentTracker, workflowTabs]);

  // Tabs that are NOT currently visible
  const overflowTabs = React.useMemo(() => {
    const nextIndex = startIndex + MAX_TABS_PER_PAGE;
    return workflowTabs.slice(nextIndex);
  }, [workflowTabs, startIndex, MAX_TABS_PER_PAGE]);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (overflowRef.current && !overflowRef.current.contains(e.target)) {
        setShowOverflowMenu(false);
      }
    };

    if (showOverflowMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOverflowMenu]);

  const handleOverflowSelect = (tab) => {
    setCurrentTracker(tab.id);

    const index = workflowTabs.findIndex((t) => t.id === tab.id);
    if (index !== -1) {
      const newStart = Math.min(
        Math.max(index - Math.floor(MAX_TABS_PER_PAGE / 2), 0),
        Math.max(workflowTabs.length - MAX_TABS_PER_PAGE, 0)
      );
      setStartIndex(newStart);
    }

    setShowOverflowMenu(false);
  };


  useEffect(() => {
    if (!workflowTabs.length) return;
    // Try to match admin group from navigation state
    const matchedTab = workflowTabs.find(
      (tab) => tab.label === assignedAdminGroup
    );

    if (matchedTab) {
      console.log(" Auto-selecting tab:", matchedTab);
      setCurrentTracker(matchedTab.id);
    } else {
      setCurrentTracker(workflowTabs[0].id);
    }
  }, [workflowTabs, assignedAdminGroup]);
  const activeStep = workflowTabs.find((tab) => tab.id === currentTracker);

  const activeTicket = activeStep?.ticketData;
  const canEdit = Boolean(activeStep?.ticketData?.can_edit);
  const isClosed = Number(activeTicket?.status?.id) === 6;

  console.log("Can Edit?", canEdit);

  useEffect(() => {
    dispatch(loadActiveEmployeeDataRequest());
    dispatch(loadGroupByTypeAdminGetDataRequest("admin"));
    dispatch(loadWorkflowDetailsGetDataRequest(params.id));
    dispatch(loadCategorySubCategoryConfigDataRequest());
    dispatch(loadStatusDropdownRequest());
  }, [dispatch, params.id]);

      // Re-fetch after save in a separate effect
    useEffect(() => {
      if (workflowSaveSuccess) {
        dispatch(loadWorkflowDetailsGetDataRequest(params.id));
      }
    }, [workflowSaveSuccess]);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       overflowRef.current &&
  //       !overflowRef.current.contains(event.target)
  //     ) {
  //       setShowOverflow(false);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  useEffect(() => {
    if (group && group.length > 0) {
      setEmployees(group);
    }
  }, [group]);

  const handleAdminGroupChange = (e, setFieldValue) => {
    const selectedGroupId = e.target.value;
    setFieldValue("adminGroup", selectedGroupId);
    dispatch(loadGroupByIDJobTitlesGetDataRequest(selectedGroupId));
  };

  // useEffect(() => {
  //   // If we have admin group and no assigned_to, fetch employees for that group
  //   if (
  //     workflowdetails?.assigned_to_admin_group
  //     // &&  !workflowdetails?.assigned_to
  //   ) {
  //     dispatch(
  //       loadGroupByIDJobTitlesGetDataRequest(
  //         workflowdetails.assigned_to_admin_group
  //       )
  //     );
  //   }
  // }, [workflowdetails, dispatch]);

  const [formInitialValues, setFormInitialValues] = useState({
    status: "",
    adminGroup: "",
    assignedTo: "",
    requestedUser: "",
    category: "",
    subcategory: "",
    categoryConfigId: "",
    solution: { solution_text: ""},
    company: "",
    location: { sap: "", district: "", region: ""},
    ticket: { cc: "", summary: "", description: "", attachments: [] },
  });
  
  const getAdminGroupIdByName = (groupName) => {
    if (!groupName || !adminGroup?.length) return "";

    const matched = adminGroup.find((g) => g.group_name === groupName);

    return matched?.group_id || "";
  };

  useEffect(() => {
    if (!activeStep?.ticketData) return;

    const ticket = activeStep.ticketData;

    const adminGroupId = getAdminGroupIdByName(ticket.admin_group);
    const initial = {
      status: ticket.status?.id || "",
      adminGroup: adminGroupId,
      assignedTo: ticket.assigned_to?.id || "",

      requestedUser: ticket.requested_for?.name || "",
      category: ticket.category?.name || "",
      subcategory: ticket.subcategory?.name || "",
      categoryConfigId: ticket.category_config?.id || "",
      solution: {
         solution_text: getLatestSolution(ticket?.solutions)
      },
      company: ticket?.company_name || "",
      location: {
        sap: ticket.location?.sap || "",
        district: ticket.location?.district || "",
        region: ticket.location?.region || "",
        
      },

      ticket: {
        summary: ticket.summary || "",
        description: ticket.description || "",
        attachments: [],
      },      
    };

    setFormInitialValues(initial);
    originalValuesRef.current = JSON.parse(JSON.stringify(initial));

    //  Load employees for this admin group
    if (adminGroupId) {
      dispatch(loadGroupByIDJobTitlesGetDataRequest(adminGroupId));
    }
  }, [activeStep, adminGroup, dispatch]);

  const validationSchema = Yup.object({
    // status: Yup.string().required("Please select a status"),
    adminGroup: Yup.string().required("Admin group is required"),
    // assignedTo: Yup.string().required("Assignee is required"),
    category: Yup.string().required("Category is required"),
    subcategory: Yup.string().required("SubCategory is required"),
    assignedTo: Yup.string().when("status", {
    is: (status) => Number(status) === 6, // 6 = Closed
    then: (schema) =>
      schema.required("Assigned To is required when status is Closed"),
    otherwise: (schema) => schema.notRequired(),
  }),
  // Solution required when status is Closed
  solution:Yup.object({
    solution_text: Yup.string().when("status", {
      is: (status) => Number(status) === 6,
      then: (schema) =>
        schema
          .required("Solution is required when status is Closed")
          .test("not-empty-html", "Solution is required when status is Closed", (val) => {
            if (!val) return false;
            const div = document.createElement("div");
            div.innerHTML = val;
            return div.textContent?.trim().length > 0;
          }),
      otherwise: (schema) => schema.notRequired(),
    }), })
  });

  const stripHtml = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const getChangedValues = (current, original) => {
    let changed = {};
    for (let key in current) {
      if (typeof current[key] === "object" && current[key] !== null) {
        const nested = getChangedValues(current[key], original[key] || {});
        if (Object.keys(nested).length > 0) {
          changed[key] = nested;
        }
      } else {
        const curr = String(current[key] ?? "");
        const orig = String(original[key] ?? "");

        // Strip HTML for both description and solution before comparing
        const htmlFields = ["description", "solution"];
        const currClean = htmlFields.includes(key) ? stripHtml(curr) : curr;
        const origClean = htmlFields.includes(key) ? stripHtml(orig) : orig;

        if (currClean !== origClean) {
          changed[key] = current[key];
        }
      }
    }
    return changed;
  };

  // const stripHtml = (html) => {
  //   const tmp = document.createElement("div");
  //   tmp.innerHTML = html;
  //   return tmp.textContent || tmp.innerText || "";
  // };

  const isImageOnlyContent = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html.trim();
    return Array.from(div.childNodes).every((node) => {
      return (
        node.nodeName === "IMG" ||
        (node.nodeName === "P" && node.querySelectorAll("img").length > 0) ||
        (node.nodeType === 3 && node.textContent.trim() === "")
      );
    });
  };

  // Changing the payload 
  const flattenPayload = (data) => {
    let flat = {};

    Object.keys(data).forEach((key) => {
      // Keep solution nested, flatten everything else
      if (key === "solution") {
        flat[key] = data[key];
      } else if (typeof data[key] === "object" && data[key] !== null) {
        Object.assign(flat, data[key]);
      } else {
        flat[key] = data[key];
      }
    });

    return flat;
  };

  const handleSubmit = (values) => {
      if (!originalValuesRef.current) return;

      const changedValues = getChangedValues(
        values,
        originalValuesRef.current
      );

      if (Object.keys(changedValues).length === 0) {
        console.log("No changes detected");
        return;
      }

      const flatPayload = flattenPayload(changedValues);

      dispatch(
        loadWorkflowDetailsAddDataRequest({
          workflowId: workflowdetails?.workflow_id,
          ticketId: activeTicket?.ticket_id,
          data: flatPayload,
        })
      );
  };

  const handleComplete = async () => {
    if (!formikRef.current) return;

    await formikRef.current.setFieldValue("status", 6);
    await formikRef.current.submitForm();
  };
  // const closeTicket = () => {
  //   dispatch(
  //     loadWorkflowDetailsAddDataRequest({
  //       workflowId: workflowdetails?.workflow_id,
  //       ticketId: activeTicket?.ticket_id,
  //       data: { status: 6 },
  //     })
  //   );
  // };
  //Reload page after request processed
  // useEffect(() => {
  //   if (shouldReload && !loading) {
  //     dispatch(loadWorkflowDetailsGetDataRequest(params.id));
  //     setShouldReload(false);
  //   }
  // }, [loading, shouldReload]);

  const checkIfChanged = (current, original) => {
    const changed = getChangedValues(current, original);
    return Object.keys(changed).length > 0;
  };

  // useEffect(() => {
  //   if (workflowdetails?.category_config_id) {
  //     setArticleID(workflowdetails.category_config_id);
  //   }
  // }, [workflowdetails]);

  const { showPrompt, confirmNavigation, cancelNavigation } = usePrompt(
    "You have unsaved changes. Are you sure you want to leave?",
    isChanged,
    true // Enable custom modal
  );

  // Add native browser alert for refresh/close
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isChanged) {
        e.preventDefault();
        e.returnValue = ""; // Required for Chrome
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isChanged]);

  // const handleAddSolution = (data) => {
  //   setFieldValue("solution", data);
  // };

  // Dlete Workflow
  const handleDeleteWorkflow = () => {
    setShowDeleteModal(true);
  };

  const confirmDeleteWorkflow = () => {
    if (!workflowdetails?.workflow_id) return;

    dispatch(loadWorkflowDeleteDataRequest(workflowdetails.workflow_id));
    setShowDeleteModal(false);
  };

  // after delete
  useEffect(() => {
    if (workflowDeleteSuccess) {

      navigate("/ticketing");
      // navigate to next workflow if exists
      // if (nextId) {
      //   navigate(`/workflow/${nextId}`);
      // } else {
      //   navigate("/ticketing");
      // }

    }
  }, [workflowDeleteSuccess]);

  return (
    <>
      <Row className="detailsPageHeader"
      >
        <Col>
          <Breadcrumbs
            children={[
              { href: "/ticketing/", label: TICKETING },
              {
                href: `/ticketing/${params.id}`,
                label: workflowdetails?.workflow_number || TICKET_DETAILS,
              },
            ]}
          />
        </Col>
        <Col xl={8} xs={12}>
          <div className="float-end">
            <PrevNextButtons
              currentId={params.id}
              // basePath={"/workflow/"}
              name={TICKETING}
            />
            <Link to='/ticketing/'>
                <DefaultButton buttonClass='default-btn-color' buttonTitle={BACKTOLIST} />
            </Link>
          </div>
        </Col>
      </Row>

      <div className="ticket-header">
        <Card className="ticket-info-card shadow-sm">
          <Card.Body>
            <Formik
              initialValues={formInitialValues}
              enableReinitialize
              innerRef={formikRef}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                if (Number(values.status) === 6) {
                  handleSubmit(values);
                  return;
                }

                handleSubmit(values);
              }}
            >
              {({ values, setFieldValue, errors, touched, resetForm }) => {
                const hasChanged = originalValuesRef.current
                  ? checkIfChanged(values, originalValuesRef.current)
                  : false;
                if (hasChanged !== isChanged) {
                  setIsChanged(hasChanged);
                }
                return (
                  <Form>
                    {/* Tabs + Buttons Row */}
                    <Row className="align-items-center mb-3 workflow-tab-hdr">
                      {/* LEFT ARROW */}
                      {showArrows && (
                        <Col xs="auto" style={{ marginRight: "-25px" }}>
                          <div
                            onClick={startIndex === 0 ? undefined : handlePrev}
                            className="workflow-arrow-icon"
                            style={{
                              cursor:
                                startIndex === 0 ? "not-allowed" : "pointer",
                              opacity: startIndex === 0 ? 0.4 : 1,
                              fontSize: "18px",
                              padding: "6px 10px",
                              userSelect: "none",
                            }}
                          >
                            ◀
                          </div>
                        </Col>
                      )}

                      {/* FIXED-WIDTH TABS CONTAINER */}
                      <Col>
                        <div
                          style={{
                            width: "580px", //  FIXED WIDTH (4 × 220px)
                            overflow: "hidden", // hide non-visible tabs
                            margin: "0 auto",
                          }}
                        >
                          <div
                            className="d-flex"
                            style={{
                              gap: "0px", // no gap between tabs
                            }}
                          >
                            {visibleTabs.map((tab) => {
                              const isActive = currentTracker === tab.id;
                              return (
                                <div
                                  key={tab.id}
                                  onClick={() => setCurrentTracker(tab.id)}
                                  className={`workflow-tab ${isActive ? "selected" : ""}`}
                                >
                                  {tab.serial}. {tab.label}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </Col>

                      {/* THREE DOTS OVERFLOW */}
                      {overflowTabs.length > 0 && (
                        <Col
                          xs="auto"
                          className="position-relative"
                          ref={overflowRef}
                        >
                          <div
                            onClick={() => setShowOverflowMenu((v) => !v)}
                            className="workflow-overflow-dots"
                          >
                            <i
                              className="fas fa-ellipsis-v"
                              style={{ fontSize: "18px" }}
                            />
                          </div>

                          {showOverflowMenu && (
                            <div
                              style={{
                                position: "absolute",
                                top: "100%",
                                right: 0,
                                zIndex: 900,
                                minWidth: "220px",
                                maxHeight: "260px",
                                overflowY: "auto",
                                background: "#fff",
                                border: "1px solid #ddd",
                                borderRadius: "6px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                              }}
                            >
                              {overflowTabs.map((tab) => (
                                <div
                                  key={tab.id}
                                  onClick={() => handleOverflowSelect(tab)}
                                  style={{
                                    padding: "8px 12px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    borderBottom: "1px solid #eee",
                                    whiteSpace: "nowrap",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.background =
                                      "#f5f5f5")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.background =
                                      "transparent")
                                  }
                                >
                                    {tab.serial}. {tab.label}
                                </div>
                              ))}
                            </div>
                          )}
                        </Col>
                      )}

                      {/* RIGHT ARROW */}
                      {showArrows && (
                        <Col xs="auto" style={{ marginLeft: "-10px" }}>
                          <div
                            onClick={
                              startIndex + MAX_TABS_PER_PAGE >=
                              workflowTabs.length
                                ? undefined
                                : handleNext
                            }
                            className="workflow-arrow-icon"
                            style={{
                              cursor:
                                startIndex + MAX_TABS_PER_PAGE >=
                                workflowTabs.length
                                  ? "not-allowed"
                                  : "pointer",
                              opacity:
                                startIndex + MAX_TABS_PER_PAGE >=
                                workflowTabs.length
                                  ? 0.4
                                  : 1,
                              fontSize: "18px",
                              padding: "6px 10px",
                              userSelect: "none",
                            }}
                          >
                            ▶
                          </div>
                        </Col>
                      )}

                      {/* Buttons */}
                      <Col className="d-flex justify-content-end gap-2">
                        <DefaultButton
                          buttonClass="btn btn-secondary"
                          buttonTitle="Cancel"
                          buttonType="button"
                          actionBlock={() => formikRef.current?.resetForm()}
                        />
                        <DefaultButton
                          buttonClass="default-btn-color"
                          buttonTitle="Apply"
                          buttonType="submit"                          
                          disabled={!isChanged || !canEdit}
                        />
                        <DefaultButton
                          buttonClass="default-btn-color"
                          buttonTitle="Completed"
                          buttonType="button"
                          actionBlock={handleComplete}
                          disabled={!canEdit || isClosed}
                        />
                        {canDelete && (
                        <DefaultButton
                          buttonClass="btn btn-danger"
                          buttonTitle="Delete"
                          buttonType="button"
                          actionBlock={handleDeleteWorkflow}
                        />
                      )}   
                      </Col>
                    </Row>

                    {/* Routing Section */}
                    <Row className="g-2">
                      <Col md={4}>
                        <label className="form-label">
                          <strong>Status</strong>
                        </label>
                        <FormikSelectField
                          name="status"
                          value={values.status}
                          onChange={(name, value) => {setFieldValue(name, value); }}
                          disabled={!canEdit}
                        >
                          {statusList.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </FormikSelectField>
                        <ErrorMessage
                          name="status"
                          component="div"
                          className="error-text"
                        />
                      </Col>

                      <Col md={4}>
                        <label className="form-label">
                          <strong>Admin Group</strong>
                        </label>
                        <FormikSelectField
                          name="adminGroup"
                          value={values.adminGroup}
                          onChange={(name, value) =>
                            handleAdminGroupChange(
                              { target: { value } },
                              setFieldValue
                            )
                          }
                          placeholder="Select a user group"
                          disabled={true}
                        >
                          <option value="">Select</option>
                          {adminGroup.map((admin) => (
                            <option key={admin.group_id} value={admin.group_id}>
                              {" "}
                              {admin.group_name}{" "}
                            </option>
                          ))}
                        </FormikSelectField>
                        <ErrorMessage
                          name="adminGroup"
                          component="div"
                          className="error-text"
                        />
                      </Col>

                      <Col md={4}>
                        <label className="form-label">
                          <strong>Assigned To</strong>
                        </label>
                        <FormikSelectField
                          name="assignedTo"
                          value={values.assignedTo}
                          //onChange={(name, value) => setFieldValue(name, value)}
                          onChange={(field, selected) =>
                            setFieldValue("assignedTo", selected)
                          }
                          placeholder="Select an employee"
                          disabled={!values.adminGroup || !canEdit}
                        >
                          <option value="">Select</option>
                          {employees.map((emp) => (
                            <option key={emp.id} value={emp.id}>
                              {" "}
                              {emp.emp_name}
                              {","} {emp.employee_id}{" "}
                            </option>
                          ))}
                        </FormikSelectField>
                        <ErrorMessage
                          name="assignedTo"
                          component="div"
                          className="error-text"
                        />
                      </Col>
                    </Row>

                    {/* Requested / Category / Subcategory */}
                    <Row className="g-2 mt-2">
                      <Col md={4}>
                        <div className="d-flex align-items-center mb-1">
                          <label className="form-label me-2 mb-0">
                            <strong>Requested User</strong>
                          </label>
                          <a
                            href={`/employees/${activeTicket?.requested_for?.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Open Employee Profile"
                          >
                            <i className="fas fa-external-link-alt location-link-icon"></i>
                          </a>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          value={values.requestedUser || ""}
                          readOnly
                        />
                      </Col>
                      {/* CATEGORY DROPDOWN */}
                      {categoryconfig?.data &&
                        Array.isArray(categoryconfig.data) && (
                          <Col md={4}>
                            <label className="form-label">
                              <strong>Category</strong>
                            </label>
                            <FormikSelectField
                              name="category"
                              value={values.category}
                              onChange={(name, value) => {
                                setFieldValue("category", value);
                                const selectedCat = categoryconfig.data.find(
                                  (cat) => cat.name === value
                                );
                                setArticleID(
                                  selectedCat?.category_config_id || ""
                                );
                                setFieldValue("subcategory", ""); // reset subcategory
                              }}
                              style={{ backgroundColor: "rgba(207, 36, 127, 1)" }}
                              //  placeholder="Select category"
                              disabled={true}
                              
                            >
                              {/* <option value="">Select Category</option> */}
                              {categoryconfig.data.map((cat) => (
                                <option key={cat.id} value={cat.name}>
                                  {cat.name}
                                </option>
                              ))}
                            </FormikSelectField>
                            <ErrorMessage
                              name="category"
                              component="div"
                              className="error-text"
                            />
                          </Col>
                        )}

                      {/* SUBCATEGORY DROPDOWN */}
                      {values.category && (
                        <Col md={4}>
                          <label className="form-label">
                            <strong>Subcategory</strong>
                          </label>
                          <FormikSelectField
                            name="subcategory"
                            value={values.subcategory}
                            disabled={true}
                            // onChange={(name, value) => {
                            //   setFieldValue(name, value);

                            //   const selectedCat = categoryconfig.data.find(c => c.id == values.category);
                            //   const selectedSub = selectedCat?.sub_category?.find(s => s.s_id == value);

                            //   if (selectedSub) {
                            //     setFieldValue("category_config_id", selectedSub.config_id);
                            //   }
                            // }}
                            // onChange={(name, value) => {
                            //     setFieldValue(name, value);
                            //     const selectedCat = categoryconfig.data.find(
                            //       (c) => c.name === values.category
                            //     );
                            //     const selectedSub = selectedCat?.sub_category?.find(
                            //       (s) => s.s_name === value
                            //     );
                            //     if (selectedSub) {
                            //       setFieldValue("category_config_id", selectedSub.config_id);
                            //     }
                            //   }}
                            onChange={(name, value) => {
                              const selected = value;
                              setFieldValue("subcategory", selected);

                              // Find matching subcategory object
                              let matched = null;

                              categoryconfig?.data?.forEach((cat) => {
                                cat?.sub_category?.forEach((sub) => {
                                  // Compare by subcategory name (your value)
                                  if (sub.s_name === selected) {
                                    matched = sub;
                                  }
                                });
                              });

                              if (matched) {
                                // Set config id
                                setFieldValue(
                                  "categoryConfigId",
                                  matched.config_id
                                );

                                // Update admin group
                                setFieldValue(
                                  "adminGroup",
                                  matched.admin_group
                                );
                                dispatch(
                                  loadGroupByIDJobTitlesGetDataRequest(
                                    matched.admin_group
                                  )
                                );

                                // Update assigned to
                                setFieldValue(
                                  "assignedTo",
                                  matched.assigned_to
                                );
                              }
                            }}
                          >
                            {/* <option value="">Select Subcategory</option> */}
                            {(() => {
                              const selectedCategory =
                                categoryconfig?.data?.find(
                                  (cat) => cat.name === values.category && 
                                  cat.ticket_type === activeTicket?.category_config?.ticket_type
                                );

                              if (
                                !selectedCategory ||
                                !Array.isArray(selectedCategory.sub_category)
                              ) {
                                return (
                                  <option disabled>
                                    {selectedCategory
                                      ? "No subcategories"
                                      : "Select category first"}
                                  </option>
                                );
                              }

                              return selectedCategory.sub_category.map(
                                (sub) => (
                                  <option key={sub.s_id} value={sub.s_name}>
                                    {sub.s_name}
                                  </option>
                                )
                              );
                            })()}
                          </FormikSelectField>
                          <ErrorMessage
                            name="subcategory"
                            component="div"
                            className="error-text"
                          />
                        </Col>
                      )}


                    {/* Divider line */}
                    <hr className="ticket-divider" />
                    {/* Ticket content area */}
                    <div>
                      {/* {uiTicketDetails && (
                        <TicketGeneral
                          values={values}
                          setFieldValue={setFieldValue}
                          ticketdetails={uiTicketDetails}
                          newMessageAttachments={newMessageAttachments}
                        />
                      )} */}
                      <TicketGeneral
                        values={values}
                        setFieldValue={setFieldValue}
                        ticketdetails={activeTicket || {}}
                        newMessageAttachments={
                          workflowdetails?.attachments || []
                        }
                        canEdit={canEdit}
                        type={"Workflow"}
                        resetTemplate={workflowSaveSuccess}
                      />
                      

                      {/* {currentTracker === 2 && <TicketMessages values={values} setFieldValue={setFieldValue} messages={workflowdetails?.messages || []} />}
                    {currentTracker === 3 && <TicketHistory values={values} setFieldValue={setFieldValue} history={workflowdetails?.history || []} />}
                    {currentTracker === 4 && (<TicketSolution values={values} setFieldValue={setFieldValue} solution= {workflowdetails.solutions || []}/>)}
                    {currentTracker === 5 && (<TicketArticle values={values} setFieldValue={setFieldValue} articleID= {articleID} />)} */}
                    </div>
                     </Row>
                  </Form>
                );
              }}                
            </Formik>
            
            {/* Floating Action Button */}
              <button
                className="floating-action-button"
                onClick={() => setShowSidePanel(true)}
                title="Quick Actions"
              >
                <i className="far fa-lightbulb"></i>        
              </button>

              {/* Ticket Insights Side Panel */}                                
                <TicketInsights
                  show={showSidePanel}
                  onClose={() => setShowSidePanel(false)}
                  insights={workflowdetails}
                  type="workflow"
                  onTabSelect={(sequenceOrder) => {        // ← ADD THIS
                    setCurrentTracker(sequenceOrder);
                  }}
                />
          </Card.Body>
        </Card>
      </div>

      {/* Custom Confirm Modal for navigation */}
      <ConfirmModal
        show={showPrompt}
        handleClose={cancelNavigation}
        handleConfirm={confirmNavigation}
        title="Unsaved Changes"
        message="You have unsaved changes. Are you sure you want to leave?"
        confirmText="Leave"
        cancelText="Stay"
      />

      {/* Delete model */}
      <Modalpopup
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        actionTitle={workflowdetails?.workflow_number || WORKFLOW}
        size="lg"
      >
        <p>Are you sure you want to delete this workflow?</p>

        <div className="d-flex justify-content-end gap-2 mt-3">
          <DefaultButton
            buttonClass="btn btn-secondary"
            buttonTitle="Cancel"
            buttonType="button"
            actionBlock={() => setShowDeleteModal(false)}
          />

          <DefaultButton
            buttonClass="btn btn-danger"
            buttonTitle="Delete"
            buttonType="button"
            actionBlock={confirmDeleteWorkflow}
          />
        </div>
      </Modalpopup>
    </>
  );
};

export default WorkflowDetails;
